import React, { useState } from 'react';
import styled from 'styled-components';
import { _ } from '_locales';
import { goToTop } from '_helpers';
import { connect } from 'react-redux';
import SPMaterialDetails from './components/SMDetails';
import SMCarousel from './components/SMCarousel';
import eventTracker from '../../../helpers/eventTracker';
import events from '../events';
import { Arrow } from '../../../styles/common-styles';

const SpotlightMaterial = ({
  spotlight_materials,
  setDisplayedContent,
  windowsWidth,
  setRef
}) => {
  const [spMaterialIndex, setSpMaterialIndex] = useState(0);
  const [showSpMaterialDetails, setShowSpMaterialDetails] = useState();

  const spMaterialClickHandler = () => {
    setShowSpMaterialDetails(true);
    setDisplayedContent('spotlightMaterial');
    eventTracker(events.HOME_SCREEN_MATERIAL_SPOTLIGHT_CTA_TAP, '');
    goToTop();
  };
  const goBackHandler = () => {
    setShowSpMaterialDetails(false);
    setDisplayedContent();
    goToTop();
    setRef('SPRef');
  };
  const nextSMHandler = () => {
    setSpMaterialIndex((prevState) => prevState + 1);
    goToTop();
  };
  const prevoiousSMHandler = () => {
    setSpMaterialIndex((prevState) => prevState - 1);
    goToTop();
  };

  return (
    <Container>
      <Title>
        {showSpMaterialDetails && (
          <Arrow background="#fff" onClick={goBackHandler} aria-label="Go back">
            &#8678;
          </Arrow>
        )}
        {showSpMaterialDetails
          ? spotlight_materials[spMaterialIndex].mat_nm : _('education.where_does_this_go')}
      </Title>

      {showSpMaterialDetails ? (
        <SPMaterialDetails
          spotlight_materials={spotlight_materials}
          spMaterialIndex={spMaterialIndex}
          prevoiousSMHandler={prevoiousSMHandler}
          nextSMHandler={nextSMHandler}
          key={spMaterialIndex}
        />
      ) : (
        <SMCarousel
          spMaterialIndex={spMaterialIndex}
          spotlight_materials={spotlight_materials}
          setSpMaterialIndex={setSpMaterialIndex}
          spMaterialClickHandler={spMaterialClickHandler}
          windowsWidth={windowsWidth}
        />
      )}
    </Container>
  );
};

export default connect(
  (store) => ({
    spotlight_materials: store.education.spotlight_materials,
    selectedLang: store.config.selectedLang
  })
)(SpotlightMaterial);

const Container = styled.div`
  box-sizing: border-box;
  padding: 10px 0;
  padding-top: 5px;
  background-color: white;
  border-radius: 10px;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 18px 0px;
  margin-top: 15px;
  overflow: hidden;
  position: relative;
`;

const Title = styled.h2`
  display:flex;
  align-items: center;
  font-size: 18px !important;
  color: rgba(64, 64, 64, 1);
  font-weight: 700 !important;
  border-bottom: 2px solid #E7ECEF;
  padding-bottom: 10px !important;
  padding-left: 10px !important;
  margin-top: 10px !important;
`;
